import mixin from '@/store/mixins/data-grid'

const { stateMixin, gettersMixin, mutationsMixin, actionsMixin } = mixin

const state = {
  ...stateMixin('component', 'name'),
  templates: [],
  templateCode: ''
}

const getters = {
  ...gettersMixin(),

  templates: (state) => state.templates,

  templateCode: (state) => state.templateCode
}

const mutations = {
  ...mutationsMixin(),

  setTemplateCode (state, code) {
    state.templateCode = code
  },

  setTemplates (state, templates) {
    state.templates = templates
  }
}

const actions = {
  ...actionsMixin({
    http: {
      headers: {
        'x-template-code': (getters) => getters.templateCode
      }
    }
  }),

  async fetchTemplates ({ commit }) {
    const templates = await this._vm.$http.make('template').getFullData()
    commit('setTemplates', templates.collection)
    if (templates.collection.length) {
      commit('setTemplateCode', templates.collection[0].code)
    }
  },

  setTemplate ({ commit, dispatch }, code) {
    commit('setTemplateCode', code)
    dispatch('fetchCollection')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
